import { createApp } from "vue";
import { createPinia } from "pinia";

import App from "./App.vue";
import router from "./router";
import i18n from "./i18";

// 导入全局 CSS 文件
import "./assets/css/main.css";
import "./assets/css/legacy/foundation.css";
import "./assets/css/legacy/site-shell.css";
import "./assets/css/ink-theme.css";

import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { initAnalytics } from "./plugins/analytics";

initAnalytics();

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(i18n);

app.mount("#app");
